import {API} from 'aws-amplify'
import {UserModel} from '../../../app/modules/auth'

export const getHeartbeat = async (currentUser: UserModel) => {
  return API.get('app_base', `/organization/${currentUser.currentOrganization}/heartbeat`, {})
}
